var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTwitterNav = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6699 8.16913C18.1856 8.46883 17.6561 8.6805 17.1039 8.79521C16.6336 8.284 15.983 7.99658 15.3039 8.00007C13.9645 7.98958 12.8669 9.1069 12.8439 10.5044C12.8445 10.6985 12.8666 10.8918 12.9099 11.0804C10.9372 10.9833 9.09487 10.0243 7.83392 8.43832C7.61823 8.81754 7.50232 9.24954 7.49794 9.69053C7.49799 10.5408 7.91147 11.3329 8.59596 11.7942C8.20506 11.7809 7.82268 11.6715 7.47994 11.4749V11.5062C7.47602 12.7274 8.30484 13.779 9.45395 14.0106C9.2426 14.0694 9.0247 14.0988 8.80597 14.0982C8.65097 14.0988 8.49629 14.0842 8.34397 14.0544C8.67526 15.0888 9.59683 15.7918 10.642 15.8074C9.77112 16.5112 8.70145 16.8943 7.59998 16.8968C7.39945 16.8966 7.19908 16.884 7 16.8593C8.12911 17.6046 9.43792 17.9998 10.774 17.9988C14.5841 18.0714 17.7292 14.9072 17.7989 10.9313C17.7996 10.8892 17.8 10.8471 17.8 10.8049C17.8 10.6985 17.8 10.5857 17.8 10.4793C18.2707 10.1202 18.6769 9.67724 19 9.17077C18.5494 9.37631 18.0723 9.5113 17.584 9.57146C18.098 9.25826 18.4843 8.75937 18.6699 8.16913Z",
    fill: "#00AAE5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 0.7,
    width: 24.6,
    height: 24.6,
    rx: 5.8,
    stroke: "#00AAE5",
    strokeWidth: 1.4
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTwitterNav, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/twitter-nav.429aff17.svg";
export { ForwardRef as ReactComponent };